import useSWRV from "swrv";
import { axios, fetcher } from "/@/modules/axios";
import {
  ManageUser,
  User,
  UserClient,
  CsvInfo,
  UserType,
  OrganizationType,
  PermissionType,
  UserPositionType,
  UserLabelType,
  UserSpecialType,
} from "/@/types";
import { errorHandle } from "/@/modules/error";
import { Ref } from "vue";

export function useSystemAdmin() {
  // jpHoliday

  function getAllUsers(
    page: Ref<number>,
    perPage: Ref<number>,
    searchName: Ref<string | undefined>,
    selectedUserType: Ref<UserType>,
    selectedUserSpecialTypes: Ref<UserSpecialType[]>,
    selectedOrganizationType: Ref<OrganizationType>,
    selectedBranchIds: Ref<number[]>,
    selectedCommitteeIds: Ref<number[]>,
    selectedPermissionType: Ref<PermissionType>,
    selectedPositionTypes: Ref<UserPositionType[]>,
    selectedLabelTypes: Ref<UserLabelType[]>,
    options: { withoutAutoJoin: boolean } = { withoutAutoJoin: false }
  ) {
    function getKey(page: Ref<number>, perPage: Ref<number>) {
      const { withoutAutoJoin } = options;

      let key = "/api/v1/system_admins/users?";
      key += `user_type=${selectedUserType.value}`;
      key += `&user_special_types=${selectedUserSpecialTypes.value.join(",")}`;
      key += `&organization_type=${selectedOrganizationType.value}`;
      key += `&branch_ids=${selectedBranchIds.value.join(",")}`;
      key += `&committee_ids=${selectedCommitteeIds.value.join(",")}`;
      key += `&permission_type=${selectedPermissionType.value}`;
      key += `&position_types=${selectedPositionTypes.value.join(",")}`;
      key += `&label_types=${selectedLabelTypes.value.join(",")}`;
      key += `&search_name=${searchName.value}`;

      if (page) {
        key += `&page=${page.value}`;
      }

      if (perPage) {
        key += `&per_page=${perPage.value}`;
      }

      if (withoutAutoJoin) {
        key += "&without_auto_join=true";
      }

      return key;
    }

    return useSWRV<{
      items: UserClient[];
      totalPages: number;
      currentPage: number;
      totalCount: number;
    }>(() => getKey(page, perPage), fetcher);
  }

  async function updateUser(id: number, prms: ManageUser) {
    try {
      await axios.patch(`/api/v1/system_admins/users/${id}`, {
        users: prms,
      });
      return true;
    } catch (error) {
      errorHandle(error);
      return false;
    }
  }

  async function getAllUsersCSV(
    ids: number[],
    { targetPropaties }: { targetPropaties: CsvInfo[] }
  ) {
    try {
      let uri = "/api/v1/system_admins/users/csv_download";

      if (ids.length) {
        uri += "?ids=" + ids.join(",");
      }

      if (targetPropaties.length) {
        uri += "&targetPropaties=" + targetPropaties.join(",");
      }

      return await axios.get(uri, {
        responseType: "blob",
      });
    } catch (e) {
      errorHandle(e);
      return null;
    }
  }

  return {
    getAllUsers,
    getAllUsersCSV,

    updateUser,
  };
}
